import api from "../../../";
import type { ApiResponse } from "../../../types";
import type {
  AuthorizationCredential,
  UpdateAuthorizationCredentialParams,
} from "./types";

export const patchAuthorizationCredential = async ({
  id,
  body,
}: UpdateAuthorizationCredentialParams): Promise<AuthorizationCredential | null> => {
  return await api
    .patch<ApiResponse<AuthorizationCredential>>(
      `/admin/sepehr/authorization-credentials/${id}/`,
      body,
    )
    .then((res) => res.data.data)
    .catch(() => null);
};
